"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.6 8.381V17.4L17.4 12 6.6 6.6v1.781z" }), "Play");
//# sourceMappingURL=Play.js.map